import { render } from "./DetailsSection.vue?vue&type=template&id=2e12a532&scoped=true&ts=true"
import script from "./DetailsSection.vue?vue&type=script&lang=ts"
export * from "./DetailsSection.vue?vue&type=script&lang=ts"

import "./DetailsSection.vue?vue&type=style&index=0&id=2e12a532&scoped=true&lang=stylus"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e12a532"]])

export default __exports__